import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle,
} from "@headlessui/react";
import { useNavigate,useOutletContext } from "react-router-dom";
import { Auth } from "aws-amplify";

import { getSurveysFromAPI, addSurveyFromAPI } from "../../services/surveyService";
import { setSurveys, setCurrentSurvey, setSurveyDetailSelectedTab, updateTabPath, updateTabStates } from "../../store/actions";

export default function Benchmarked(props) {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const themeMode = useSelector((state) => state.themeMode);
    const benchmarkeds = useSelector((state) => state.benchmarkeds);
    const topMenuTabs = useSelector((state) => state.topMenuTabs);
    const leftMenuVisibility = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
    ).states.leftMenuVisibility;
    // const themeMode = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.themeMode;
    // const benchmarkeds = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.benchmarkeds;

    let [token, setToken] = useState("");
    const [open, setOpen] = useState(false);
    const [showSearchBar, setShowSearchBar] = useState(false);
   const { searchTerm, setSearchTerm } = useOutletContext();

    const [filterSearchTerm, setFilterSearchTerm] = useState("");
    const [clearFilter, setClearFilter] = useState(true);
    const [selectedLabel, setSelectedLabel] = useState(""); // Store selected label
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [selectedSurveyName, setSelectedSurveyName] = useState("");
    const [selectedFunction, setSelectedFunction] = useState("");
    const [selectedFunctionParam, setSelectedFunctionParam] = useState("");

    const [filteredItems, setFilteredItems] = useState([]);

    async function checkAuth() {
        // window.location.reload();
        try {
            const cognitoUser = await Auth.currentAuthenticatedUser();
            const currentSession = await Auth.currentSession();
            await cognitoUser.refreshSession(
                currentSession.refreshToken,
                (err, session) => {
                    const { idToken, refreshToken, accessToken } = session;
                    getToken(idToken.jwtToken);
                }
            );
        } catch (e) {
            // console.log('Unable to refresh Token', e);
        }
    }

    useEffect(() => {
        getToken();
        dispatch(updateTabPath(topMenuTabs.activeTab, 'Benchmarked', `/home/benchmarked`));
    }, []);

    useEffect(() => {
        setFilteredItems(benchmarkeds);
    }, [benchmarkeds]);

    useEffect(() => {
        if (props.searchTerm !== "") {
            const _items = benchmarkeds.filter((item) =>
                item.survey_name.toLowerCase().includes(props.searchTerm?.toLowerCase())
            );
            setFilteredItems([...new Set([..._items])]);
        } else {
            setFilteredItems(benchmarkeds);
        }
    }, [props.searchTerm]);

  async function getToken(token) {

      const currentSession = await Auth.currentSession();
      setToken(currentSession.idToken.jwtToken);
    
  }

    useEffect(() => {
        if (token.length > 0) {
            if (selectedFunction === "getSurveys") {
                getSurveys(selectedFunctionParam);
            } else if (selectedFunction === "createBenchmarkedSurvey") {
                createBenchmarkedSurvey(selectedFunctionParam);
            }
            setSelectedFunction("");
            setSelectedFunctionParam("");
        }
    }, [token]);

    async function getSurveys(new_survey_id) {
        try {
            const result = await getSurveysFromAPI(token);

            result["surveys"].forEach((survey) => {
                survey["responded"] = result["userSurveyItems"].filter(
                    (item) => item.survey_id === survey.ID && item.is_completed).length + "/"
                    + result["userSurveyItems"].filter((item) => item.survey_id === survey.ID).length + " Responded";
            });
            dispatch(setSurveys(result["surveys"]));
            if (new_survey_id) {
                dispatch(updateTabStates(topMenuTabs.activeTab, "currentSurvey", result["surveys"].find(survey => survey.ID === new_survey_id)));
                dispatch(updateTabStates(topMenuTabs.activeTab, "surveyDetailSelectedTab", "Summary"));
                dispatch(updateTabPath(topMenuTabs.activeTab, 'Summary', `/surveys/${new_survey_id}/summary`));
                dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', false));
                navigate(`/surveys/${new_survey_id}/summary`);
            }

        } catch (error) {
            if (error?.message === "Request failed with status code 401") {
                setSelectedFunction("getSurveys");
                setSelectedFunctionParam(new_survey_id);
                checkAuth();
            }
        }
    }

    function classNames(...classes) {
        return classes.filter(Boolean).join(" ");
    }

    const fixDateFormat = (date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const sortOptions = [
        { name: "Name", href: "#", current: false },
        { name: "Email", href: "#", current: false },
        { name: "Status", href: "#", current: true },
    ];

    const [tabs, setTabs] = useState([
        {
            name: "Surveys",
            href: "#",
            current: true,
        },
        {
            name: "Create From File",
            href: "#",
            current: false,
        },
        {
            name: "Q - Robot",
            href: "#",
            current: false,
        },
        {
            name: "Benchmarked",
            href: "#",
            current: false,
        },
    ]);

    const handleMenuItemClick = (label) => {
        setSelectedLabel(label); // Set selected label for filtering
        setShowSearchBar(true); // Show the search bar
    };

    const togglePopup = () => {
        setIsPopupVisible(!isPopupVisible);
    };

    useEffect(() => {
        if (searchTerm !== "") {
            const _items = benchmarkeds.filter((item) =>
                item.survey_name.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredItems([...new Set([..._items])]);
        } else {
            setFilteredItems(benchmarkeds);
        }
    }, [searchTerm]);

    const tabMenuClickHandler = (tabName) => {
        const newTabs = tabs.map((tab) => {
            if (tab.name === tabName) {
                tab.current = true;
            } else {
                tab.current = false;
            }
            return tab;
        });
        setTabs(newTabs);
    };

    async function createBenchmarkedSurvey(surveyName) {
        const selectedBenchmarkedSurvey = filteredItems.find(item => item.survey_name === surveyName);
        try {
            dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', true));
            const userCognitoInfo = await Auth.currentUserInfo()
            const obj = {
                survey_name: selectedBenchmarkedSurvey.survey_name,
                organization: userCognitoInfo.attributes['custom:org_name'],
                stages: selectedBenchmarkedSurvey.stages,
                content: selectedBenchmarkedSurvey.content,
            };
            await addSurveyFromAPI(token, obj)
                .then(async (result) => {
                    getSurveys(result.survey_id);
                })
                .catch((error) => {
                    if (error.message === "Request failed with status code 400") {
                    } else if (error.message === "Request failed with status code 401") {
                        setSelectedFunction("createBenchmarkedSurvey");
                        setSelectedFunctionParam(surveyName);
                        checkAuth();
                    }
                });
        } catch (error) {
            dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', false));
        }
    }

    return (
        <div className={`flex flex-wrap  ${leftMenuVisibility=="show" ? 'justify-start xs:justify-center' : 'justify-center'} md:justify-start gap-12 p-4 pl-6 xs:pl-12 mx-auto mt-4`}>
            {filteredItems.map((item) => (
                <div
                    key={item.ID}
                    id="benchmarkedCardBody"
                    onClick={() => {
                        setSelectedSurveyName(item.survey_name);
                        setOpen(!open);
                    }}
                    className={`shadow-md rounded-lg pt-2 px-0 pb-0 w-[250px] sm:w-[300px] 
                      ${themeMode === "dark" ?
                            "bg-[#dedef00a] hover:bg-[#282834] text-white cursor-pointer hover:shadow-[0_0_1px_1px_#205DC2] hover:animate-[ease-in-out_1s]"
                            : "bg-white text-gray-800 cursor-pointer hover:bg-gray-100 hover:shadow-[0_0_1px_1px_#205DC2]"}
                        ${item.content ? "" : "pointer-events-none opacity-40 filter grayscale"}
                      `}
                >
                    <div className="p-4 py-1 rounded-lg">
                        <div className="flex justify-between items-center mb-3">
                            <div className="flex items-center">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                    className="size-6"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"
                                    />
                                </svg>

                                <span className="size-5 whitespace-nowrap text-xs text-[#A1A1A1]">
                                    Analytics
                                </span>
                            </div>
                        </div>
                        <p
                            className="text-xs sm:text-sm font-semibold mb-4"
                            title={item.survey_name}
                        >
                            {item.survey_name.length > 30
                                ? item.survey_name.slice(0, 30) + "..."
                                : item.survey_name}
                        </p>
                        <p className="text-[0.70rem] mb-1">
                            <span>Sections: </span>{item.summary.section_count}
                        </p>
                        <p className="text-[0.70rem] mb-1">
                            <span>Pages: </span>{item.summary.page_count}
                        </p>
                        <p className="text-[0.70rem] mb-1">
                            <span>Questions: </span>{item.summary.question_count}
                        </p>
                    </div>
                </div>
            ))}
            <Dialog open={open} onClose={setOpen} className="relative z-10">
                <DialogBackdrop
                    transition
                    className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${themeMode === "dark"
                                ? "bg-[#2a2939] border-white-09"
                                : "bg-[#FFFFFF] border-black-09 "
                                } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                        >
                            <div>
                                <div className="mt-0 text-start sm:mt-0">
                                    <DialogTitle
                                        as="h3"
                                        className={`text-base font-semibold ${themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                                            }`}
                                    >
                                        Create Survey
                                    </DialogTitle>
                                    <div className="mt-1">
                                        <p
                                            className={`text-xs sm:text-sm ${themeMode === "dark" ? "text-white-8" : "text-black-8"
                                                }`}
                                        >
                                            Are you sure you want to create a new survey with{" "}
                                            {selectedSurveyName} template?
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                                <button
                                    type="button"
                                    onClick={() => createBenchmarkedSurvey(selectedSurveyName)}
                                    className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${themeMode === "dark"
                                        ? " border-white-09  "
                                        : " border-black-09 "
                                        } px-3 py-2 text-xs sm:text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                                >
                                    Yes
                                </button>
                                <button
                                    type="button"
                                    data-autofocus
                                    onClick={() => setOpen(false)}
                                    className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid ${themeMode === "dark"
                                        ? "bg-white-02 border-white-09 text-white-8 hover:text-white hover:bg-white-04"
                                        : "bg-black-02 border-black-09 text-black-8 hover:text-black hover:bg-black-04"
                                        } px-3 py-2 text-xs sm:text-sm font-semibold shadow-sm sm:col-start-1 sm:mt-0`}
                                >
                                    No
                                </button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}
